import { InvoiceDetailSlidein } from '@/components/accounts-payable/invoice-detail/invoice-detail-slidein';
import { InvoiceListNavigation } from '@/components/accounts-payable/invoice-detail/InvoiceListNavigation';
import { useNavigate, useParams } from '@tanstack/react-router';

export function Route() {
  const { invoiceId } = useParams({
    from: '/authenticated/accounts-payable/invoices/$invoiceId',
  });
  const navigate = useNavigate();

  return (
    <InvoiceDetailSlidein
      invoiceId={invoiceId}
      headerLeading={<InvoiceListNavigation invoiceId={invoiceId} />}
      isOpen
      onOpenChange={() => {
        navigate({
          to: '..',
          // Keep the list's filters and the scroll position the table had.
          search: true,
          resetScroll: false,
          viewTransition: true,
        });
      }}
    />
  );
}
